module.exports = __webpack_public_path__ + "images/marketing_site/cloops_thumb.png";